module.exports = __webpack_public_path__ + "img/logo.1a64cdb8.png";